<template functional>
  <div
    v-bind="data.attrs"
    :class="['Set', data.class, data.staticClass]"
    :style="data.style"
    v-on="listeners">
    <SetIcon
      v-if="props.icon"
      :class="$options.passedClasses(data.staticClass)"
      :icon="props.icon" />
    <slot name="icon" />
    <div class="body">
      <div v-if="props.label" class="label">
        {{ props.label }}
      </div>
      <div class="value">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import SetIcon from './SetIcon'
import Vue from 'vue'

const sizeClasses = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl',
  'xxxl',
]

const themeClasses = [
  'danger',
  'fancy',
  'info',
  'main',
  'neutral',
  'secondary',
  'success',
  'warning',
]

const passedClasses = [...sizeClasses, ...themeClasses]

Vue.component('SetIcon', SetIcon)

export default {
  props: {
    icon: String,
    label: String,
    size: String,
    theme: String,
  },
  passedClasses(staticClass) {
    if (!staticClass) return

    return passedClasses
      .filter(passedClass => staticClass.includes(passedClass))
      .join(' ')
  },
}
</script>

<style lang="scss">
.Set {
  display: flex;

  > .body {
    overflow: hidden;
    width: 100%;

    > .label {
      color: $text-color-light;
      font-size: $h6;
      line-height: 1rem;
    }

    > .value {
      @include ellipsis;
      font-weight: $semibold;
    }
  }

  // size
  &.lg {
    > .body {
      > .label {
        font-size: $h5;
      }

      > .value {
        font-size: $h5;
      }
    }
  }

  &.xl {
    > .body {
      .SetIcon {
        margin-right: 1rem;
      }

      > .label {
        font-size: $h5;
      }

      > .value {
        font-size: $h4;
      }
    }
  }
}
</style>
